import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ModalDirective} from 'ng-uikit-pro-standard';
import { Localization } from "../../enums/localization";

@Component({
  selector: 'app-delete-confirm-modal',
  templateUrl: './app-delete-confirm-modal.component.html',
})
export class AppDeleteConfirmModalComponent {

  @Output() delete = new EventEmitter<number>();
  @Output() closed = new EventEmitter<any>();
  @ViewChild('modal') modal: ModalDirective;

  public id: number;
  public message: string;
  public messageParams: any;
  public confirmLabel: string;
  public cancelLabel: string;
  public readonly Localization = Localization;

  show(id: number, message: string = '', messageParams: any = {}, confirmLabel: string = this.Localization.Delete,
       cancelLabel: string = this.Localization.Cancel) {
    this.id = id;
    this.message = message;
    this.messageParams = messageParams;
    this.confirmLabel = confirmLabel;
    this.cancelLabel = cancelLabel
    this.modal.show();
  }

  confirm() {
    this.delete.emit(this.id);
    this.modal.hide();
  }

  close() {
    this.closed.emit(null);
    this.modal.hide();
  }
}
